import { render, staticRenderFns } from "./BuilderScopeReq.vue?vue&type=template&id=32a76e89"
import script from "./BuilderScopeReq.vue?vue&type=script&lang=js"
export * from "./BuilderScopeReq.vue?vue&type=script&lang=js"
import style0 from "./BuilderScopeReq.vue?vue&type=style&index=0&id=32a76e89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports